<template>
    <portal v-if="absolute" to="app-root">
        <transition
            :css="false"
            @before-enter="transitionBeforeEnter"
            @enter="transitionEnter"
            @leave="transitionLeave"
        >
            <div class="loading" :class="mainClass" key="loading">
                <slot>
                    <svg class="default-spinner" viewBox="25 25 50 50">
                        <circle class="path" cx="50" cy="50" r="20" fill="none"/>
                    </svg>
                </slot>
                <slot name="after"></slot>
            </div>
        </transition>
    </portal>
    <transition
        v-else
        :css="false"
        @before-enter="transitionBeforeEnter"
        @enter="transitionEnter"
        @leave="transitionLeave"
    >
        <div class="loading" :class="mainClass" key="loading">
            <slot>
                <svg class="default-spinner" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none"/>
                </svg>
            </slot>
            <slot name="after"></slot>
        </div>
    </transition>
    <!-- <transition name="el-fade-in"> -->
        <!-- <component v-bind:is="componentName" to="app-root">
            <transition
                name="el-fade-in"
                :css="false"
                @before-enter="transitionBeforeEnter"
                @enter="transitionEnter"
                @leave="transitionLeave"
                appear
            >
                <div class="loading" :class="mainClass" key="loading">
                    <slot>
                        <svg class="default-spinner" viewBox="25 25 50 50">
                            <circle class="path" cx="50" cy="50" r="20" fill="none"/>
                        </svg>
                    </slot>
                    <slot name="after"></slot>
                </div>
            </transition>
        </component> -->
    <!-- </transition> -->
</template>

<script>
import Progress from '@/components/v3/progress/Progress.vue'
import anime from 'animejs/lib/anime.es.js';

export default {
    components: {
        Progress
    },
    inheritAttrs: false,
    props: {
        absolute: {
            type: Boolean,
            default: false
        },
        duration: {
            type: Number,
            default: 125
        },
        background: {
            type: Boolean,
            default: true
        },
        topZIndex: {
            type: Boolean,
            default: false
        },
        relative: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            abs: this.absolute,
            transitions: [],
            currentTransition: null
        }
    },
    computed: {
        mainClass() {
          return [
            this.isAbsolute ? 'loading-absolute' : '',
            this.$vnode.data.staticClass,
            this.background ? '' : 'no-background',
            this.topZIndex ? 'top-z-index' : '',
            this.relative ? 'is-relative' : ''
          ]
        },
        componentName() {
            return this.isAbsolute ? 'portal' : 'div'
        },
        isAbsolute() {
            return this.abs
        }
    },
    methods: {
        addTransition(type, anim, el, done) {
            const transition = {
                type,
                anim,
                el,
                done
            }
            this.transitions.push(transition)
            this.executeNextTransition()
        },
        executeNextTransition() {
            if (this.currentTransition) return
            if (this.transitions.length === 0) return

            this.currentTransition = this.transitions.shift()
            this.currentTransition.anim.complete = (anim) => {
                if (this.currentTransition.done) this.currentTransition.done()
                this.currentTransition = null
                this.executeNextTransition()
            }

            anime(this.currentTransition.anim)
            this.$emit('transition', this.currentTransition)
        },
        transitionBeforeEnter(el) {
            // el.style.opacity = "0"
            // el.style.transform = "scale(0.95)"
        },
        transitionEnter(el, done) {
            this.addTransition(
            'enter',
            {
                targets: el,
                opacity: [0, 1],
                easing: 'easeInOutQuad',
                duration: this.duration
            },
            el,
            done)
        },
        transitionLeave(el, done) {
            this.addTransition(
            'leave',
            {
                type: 'leave',
                targets: el,
                opacity: 0,
                easing: 'easeInOutQuad',
                duration: this.duration
            },
            el,
            done)
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.loading
    position absolute
    top 0
    left 0
    min-height 48px
    width 100%
    height 100%
    border-radius inherit
    backdrop-filter blur(2px)
    background-color rgba(255, 255, 255, 0.9)
    z-index 1000
    display flex
    flex-direction column
    justify-content center
    align-items center
    box-sizing border-box

    &.no-background
        backdrop-filter none
        background-color transparent

    .default-spinner
        height 42px
        width 42px
        animation loading-rotate 2s linear infinite

        .path
            animation loading-dash 1.5s ease-in-out infinite
            stroke-dasharray 90,150
            stroke-dashoffset 0
            stroke-width 2
            stroke $color-primary
            stroke-linecap round

    & > span
        font-weight bold
        margin-top 16px

    &.loading-absolute
        position fixed
        width 100vw
        height 100vh
        z-index 10000
        color $color-primary

    &.top-z-index
        z-index 10000

    &.is-relative
        position relative

    &.white-spinner

        .default-spinner

            .path
                stroke white

</style>



// WEBPACK FOOTER //
// src/components/v3/loading/Loading.vue